<template>
  <el-dialog :title="industry ? industry.bd_name : ''" :visible="active && !!industry" custom-class="us-industry-dialog market-board-dialog" width="min(620px, 90vw)" top="10vh" append-to-body @close="$emit('close')">
    <div class="us-industry-stocks home-quotes-scroll" v-loading="loading" element-loading-background="var(--theme-panel)">
      <table class="home-quotes-table">
        <thead><tr><th scope="col">代码</th><th scope="col">名称</th><th scope="col">最新价</th><th scope="col">涨跌幅</th></tr></thead>
        <tbody>
          <tr v-for="item in sharedStockRows(stocks, 'us')" :key="item.code" tabindex="0" @click="$emit('select-stock', item)" @keydown.enter="$emit('select-stock', item)">
            <td>{{ item.code }}</td><td>{{ item.prod_name }}</td><td>{{ price(item.last_px) }}</td>
            <td :class="Number(item.px_change_rate) > 0 ? 'rise' : Number(item.px_change_rate) < 0 ? 'fall' : ''">{{ percent(item.px_change_rate) }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="error" class="dialog-state" role="alert">{{ error }} <button type="button" @click="load">重试</button></div>
      <div v-else-if="!loading && !stocks.length" class="dialog-state">暂无行业股票数据</div>
    </div>
  </el-dialog>
</template>

<script>
import { quotePercent } from '@/utils/quoteDisplay'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
import { getUSIndustryStocks } from '../usApi'
import { pollMarket } from '@/utils/marketRefresh'
import { getStockQuotes } from '@/utils/stockQuotes'
import { stockSelection } from '@/views/stock/stockSelection'
import { quoteNumber, quotePrice } from '@/utils/quoteDisplay'

export default {
  name: 'USIndustryDialog',
  props: { industry: { type: Object, default: null }, active: { type: Boolean, default: true } },
  data() { return { stocks: [], loading: false, error: '', requestId: 0 } },
  watch: {
    industry() { this.stopPolling(); if (this.industry) this.activate(); else { this.requestId++; this.stocks = [] } },
    active(value) { if (value) this.activate(); else this.stopPolling() }
  },
  mounted() { if (this.active && this.industry) this.activate() },
  beforeDestroy() { this.disposed = true; this.requestId++; this.stopPolling() },
  methods: {
    price: quotePrice,
    sharedStockRows,
    stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
    async activate() {
      if (this.disposed || !this.active || !this.industry || this.stopRefresh) return
      try { await this.load() }
      finally {
        if (!this.disposed && this.active && this.industry && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.refreshMarket(), 'us')
      }
    },
    async refreshMarket() {
      if (this.disposed || !this.active || !this.industry || this.loading || !this.stocks.length) return
      const requestId = this.requestId, code = this.industry.bd_code
      const codeOf = item => stockSelection({ ...item, market: 'us' }).code
      const codes = [...new Set(this.stocks.map(codeOf).filter(value => /^us[A-Za-z0-9][A-Za-z0-9._-]{0,39}$/.test(value)))]
      if (!codes.length) return
      const quotes = await getStockQuotes(codes.join(','))
      if (requestId !== this.requestId || !this.active || !this.industry || code !== this.industry.bd_code) return
      this.stocks = this.stocks.map(item => {
        const quote = quotes[codeOf(item)]
        return Array.isArray(quote) && quoteNumber(quote[3]) > 0 ? { ...item, prod_name: quote[1] || item.prod_name, last_px: quote[3], px_change_rate: quoteNumber(quote[32]) == null ? item.px_change_rate : quote[32] } : item
      })
    },
    percent: quotePercent,
    async load() {
      if (this.disposed || !this.active || !this.industry) return
      const requestId = ++this.requestId
      this.stocks = []
      this.error = ''
      this.loading = false
      if (!this.industry) return
      if (!this.industry.bd_code || this.industry.bd_code === '--') {
        this.error = '行业代码缺失，暂时无法加载。'
        return
      }
      this.loading = true
      try {
        const stocks = await getUSIndustryStocks(this.industry.bd_code)
        if (requestId !== this.requestId) return
        if (!Array.isArray(stocks)) throw new Error('invalid response')
        this.stocks = stocks
      } catch (error) {
        if (requestId === this.requestId) this.error = '行业股票加载失败，请重试。'
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    }
  }
}
</script>
